import { AppEnum } from '~/composables/useGeneralStore';
import { filter } from 'lodash-es';


export default defineNuxtRouteMiddleware(async (to, from) => {
  const appCookie = useCookie('app');
  const dynamicsSchema = useState('dynamicsSchema');
  const generalStore = useGeneralStore();
  const path = filter(to.path.split('/'));
  if(Object.values(AppEnum).includes(path[0] as AppEnum)) {
    appCookie.value = path[0];
    generalStore.setApp(path[0]);

    try {
      const {data} = await useTenantFetch(`/api/dynamics?app=${path[0]}`);
      dynamicsSchema.value = data.value;
    }catch(err) {
      log(err)
    }
  }
});